export default __webpack_public_path__ + "static/media/logo1.abd47902.png";